import Cookies from 'universal-cookie';
import { useEffect, useState } from 'react';

const cookies = new Cookies();

export function useCookieListener(cookieName: string, interval = 1000) {
  const [cookieValue, setCookieValue] = useState(cookies.get(cookieName));

  useEffect(() => {
    const checkCookieChange = () => {
      const currentValue = cookies.get(cookieName);
      if (currentValue !== cookieValue) {
        setCookieValue(currentValue);
      }
    };

    const intervalId = setInterval(checkCookieChange, interval);

    return () => clearInterval(intervalId);
  }, [cookieValue, cookieName, interval]);

  return cookieValue;
}
